import { useHistory } from 'react-router-dom';
import { Card, CardContent, CardMedia, TextField, CircularProgress, createStyles, Dialog, DialogActions, DialogContent, FormControl, Grid, makeStyles, MenuItem, Select } from '@material-ui/core/'
import { useForm } from "react-hook-form";
import AuthContext from './AuthContext'
import React, { useContext, useEffect, useState } from 'react'
import './AuthComps.scss'
import axios from 'axios';
import '../common/BForm.scss'
import { toast } from 'react-toastify';
import { DateTime } from 'luxon';
import { SDialogButton, SDialogSubtitle, SDialogTitle, SInputLabel, SLoginButton } from '../common/BCommonComponents';
import { Theme } from '@material-ui/core/styles';
import { payloadLogin } from './AuthReducer';
import { CanaleAccessoEnum, ComboBoxDTO, PrestazioneConfigDTO, PuntoServizioDTO, UserRole } from '../common/Dtos';
import { transpileModule } from 'typescript';

function Login() {
	const {register, handleSubmit, errors} = useForm();
	const history = useHistory();
	const auth = useContext(AuthContext)
	const [currentSendingRequest, setcurrentSendingRequest] = useState<boolean>(false)
	const [loginError, setLoginError] = useState<boolean>(false)
	const [open, setOpen] = useState(false);
	const [openOTP, setOpenOTP] = useState(false);
	const [userName, setUserName] = useState<string>('');
	const [password, setPassword] = useState<string>('');
	const [otpExpired, setOtpExpired] = useState<boolean>(false);
	const [loginResponse, setLoginResponse] = useState<payloadLogin>({
		login: '',
		prettyName: '',
		cooperativa: '',
		token: '',
		expiration: '',
		roles: [],
		puntiServizio: [],
		checkEmail: false,
		email: '',
		pswExpirationDate: '',
		checkVerificaEmail: false,
		id: '',
		puntoServizioLogged: {
			cooperativa: '',
			createdBy: '',
			createdDate: '',
			id: '',
			indirizzo: '',
			lastModifiedBy: '',
			lastModifiedDate: '',
			name: '',
			puntoServizioConfig: false,
			operatori: [],
			asl: '',
			telefono: '',
			email: '',
			codiceTemporaneo: '',
			codiceDefinitivo: '',
			action: '',
			cooperativaName: '',
		},
		canale: '',
		prestazioniConfList: [],
		backofficeInCorso: 0
	});

	useEffect(() => {
		const localLoginPayloadStr = localStorage.getItem('payloadLogin');
		if (localLoginPayloadStr) {
			const payloadLogin = JSON.parse(localLoginPayloadStr) as payloadLogin;
			if (DateTime.fromISO(payloadLogin.expiration) > DateTime.now()) {
				auth.dispatch({
					type: 'LOGIN', payload:
					payloadLogin
				})
				history.push("/dashboard");
			} else {
				localStorage.clear();
			}
		}

	}, [auth, history])


	const onSubmit = (data: any) => {
		setcurrentSendingRequest(true)
		apiGetToken(data.username, data.password)
	}

	const apiGetToken = (user: string, pass: string) => {
		const encodedPsw = btoa(pass);
		// axios.post('http://localhost:8083/auth/authentication/authenticate', {username: user, password: encodedPsw})
		axios.post('/auth/authentication/authenticate', {username: user, password: encodedPsw})
			.then(res => {
				setUserName(user);
				setPassword(pass);
				const payload: payloadLogin = {
					login: res.data.login,
					prettyName: res.data.prettyName,
					cooperativa: res.data.cooperativa,
					token: res.data.token,
					expiration: res.data.expiration,
					roles: res.data.roles,
					puntiServizio: res.data.puntiServizio,
					id: res.data.id,
					email: res.data.email,
					pswExpirationDate: res.data.pswExpirationDate,
					checkEmail: res.data.checkEmail,
					checkVerificaEmail: res.data.checkVerificaEmail,
					puntoServizioLogged: loginResponse.puntoServizioLogged,
					canale: '',
					prestazioniConfList: [],
					backofficeInCorso: 0
				}
				setLoginResponse(payload);
				if (res.data.checkEmail && res.data.checkVerificaEmail) {
					setOpenOTP(true);
				} else {
					checkOpenPuntiServizio();
				}
			})
			.catch(error => {
				toast.error('🛑 Errore durante il login');
				setcurrentSendingRequest(false)
				setLoginError(true)
				console.log(error)
			});
	}

	const checkOpenPuntiServizio = () => {
		if (loginResponse.roles && (loginResponse.roles.indexOf(UserRole.REPORT) >= 0)) {
			handleCloseNoPuntiServizio(loginResponse);
		} else {
			setOpen(true);
		}
	}

	const handleCloseOTP = (otp: string) => {
		if (axios) {
			const encodedPsw = btoa(password);
			const otpVerifica = {
				username: userName,
				otp: otp,
				rememberMe: false,
				password: encodedPsw
			}
			// axios.post('http://localhost:8083/auth/otp/verify-otp', otpVerifica)
			axios.post('/auth/otp/verify-otp', otpVerifica)
				.then(res => {
					setOpenOTP(false);
					setOtpExpired(false);
					setPassword('');
					toast.success("OTP verificato con successo!");
					const payload: payloadLogin = {
						login: res.data.login,
						prettyName: res.data.prettyName,
						cooperativa: res.data.cooperativa,
						token: res.data.token,
						expiration: res.data.expiration,
						roles: res.data.roles,
						puntiServizio: res.data.puntiServizio,
						id: res.data.id,
						email: res.data.email,
						pswExpirationDate: res.data.pswExpirationDate,
						checkEmail: res.data.checkEmail,
						checkVerificaEmail: res.data.checkVerificaEmail,
						puntoServizioLogged: loginResponse.puntoServizioLogged,
						canale: '',
						prestazioniConfList: [],
						backofficeInCorso: 0
					}
					setLoginResponse(payload);
					checkOpenPuntiServizio();
				})
				.catch(error => {
					if (error.response.status === 406) {
						setOtpExpired(true);
					} else {
						toast.error("🛑 Errore durante la verifica dell'OTP");
						console.log(error);
						setOpenOTP(true);
					}
				});
		}
	};

	const handleSendNewOtp = () => {
		if (axios) {
			const encodedPsw = btoa(password);
			const otpReload = {
				username: userName,
				password: encodedPsw
			}
			// axios.post('http://localhost:8083/auth/otp/send-otp', otpReload)
			axios.post('/auth/otp/send-otp', otpReload)
				.then(res => {
					setOtpExpired(false);
					toast.success("Nuovo OTP inviato con successo!");
				})
				.catch(error => {
					if (error.response.status === 406) {
						setOtpExpired(true);
					} else {
						toast.error("🛑 Errore durante l'invio dell'OTP");
						console.log(error);
						setOpenOTP(true);
					}
				});
		}
	}

	const handleClose = (punto: PuntoServizioDTO, canale: string, prestazioniConfList: PrestazioneConfigDTO[]) => {
		setOpen(false);
		auth.dispatch({
			type: 'LOGIN', payload:
				{
					login: loginResponse.login,
					prettyName: loginResponse.prettyName,
					cooperativa: loginResponse.cooperativa,
					token: loginResponse.token,
					expiration: loginResponse.expiration,
					roles: loginResponse.roles,
					puntiServizio: loginResponse.puntiServizio,
					pswExpirationDate: loginResponse.pswExpirationDate,
					id: loginResponse.id,
					email: loginResponse.email,
					puntoServizioLogged: punto,
					canale: canale,
					checkEmail: loginResponse.checkEmail,
					checkVerificaEmail: loginResponse.checkVerificaEmail,
					prestazioniConfList: prestazioniConfList,
					backofficeInCorso: 0
				}
		})

		toast.success('Welcome Back  ' + loginResponse.prettyName + "  !");
		history.push('/dashboard');
	};

	const handleCloseNoPuntiServizio = (payload: any) => {
		setOpen(false);
		auth.dispatch({
			type: 'LOGIN', payload:
				{
					login: payload.login,
					prettyName: payload.prettyName,
					cooperativa: payload.cooperativa,
					token: payload.token,
					expiration: payload.expiration,
					roles: payload.roles,
					puntiServizio: payload.puntiServizio,
					pswExpirationDate: payload.pswExpirationDate,
					id: payload.id,
					puntoServizioLogged: undefined,
					canale: '',
					email: payload.email,
					checkEmail: payload.checkEmail,
					checkVerificaEmail: payload.checkVerificaEmail,
					prestazioniConfList: [],
					backofficeInCorso: 0
				}
		})

		toast.success('Welcome Back  ' + loginResponse.prettyName + "  !");
		history.push('/export');
	};

	return (
		<>
			<div id="login-container">
				<Card className="login-card">
					<CardMedia
						className="top-img-login"
						image="/logo_orizz.svg"
						title="logo"
					/>
					<CardContent>
						<form className="b-form" onSubmit={handleSubmit(onSubmit)}>
							<div className="b-form-field-group">
								<label className="b-form-field-label" htmlFor="b-form-field-id-1">Username</label>
								<input className="b-form-field-input" type="text" name="username" id="b-form-field-id-1" autoComplete="on" placeholder="Email"
											 ref={register({required: {value: true, message: "Campo obbligatorio"}})}/>
								<span className="b-form-error-req">{errors?.email?.message}</span>

							</div>
							<div className="b-form-field-group">
								<label className="b-form-field-label" htmlFor="b-form-field-id-2">Password</label>
								<input className="b-form-field-input" type="password" name="password" id="b-form-field-id-2" autoComplete="on" placeholder="Password"
											 ref={register({required: {value: true, message: "Campo obbligatorio"}})}/>
								<span className="b-form-error-req">{errors?.password?.message}</span>
								{loginError && <span className="b-form-error-req">Controlla username e password</span>}

							</div>
							<div>
								<SLoginButton minwidth={98} type="submit">ACCEDI</SLoginButton>
							</div>
							{currentSendingRequest && <CircularProgress/>}
							{/*<Button variant="contained" color="secondary" onClick={fakelogin}>Fake login</Button>*/}
						</form>
					</CardContent>
					<img className="bottom-img-login" src="/login_img.png" alt="illustrazione scrivania"></img>
				</Card>
				<AfterLoginDialog open={open} username={userName} onClose={handleClose} puntiservizio={loginResponse.puntiServizio}/>
				<AfterLoginShowOTPDialog open={openOTP} username={userName}
																 onClose={handleCloseOTP} onReloadOtp={handleSendNewOtp}
																 expiredOtp={otpExpired}/>
			</div>
		</>
	)
}

export interface DialogPropsOTP {
	open: boolean;
	username: string;
	onClose: (otp: string) => void;
	onReloadOtp: () => void;
	expiredOtp: boolean;
}


function AfterLoginShowOTPDialog(props: DialogPropsOTP) {
	const {onClose, username, open, onReloadOtp, expiredOtp} = props;
	const [otp, setOtp] = useState<string>('');
	const auth = useContext(AuthContext);
	const [errorOtp, setErrorOtp] = useState<boolean>(false);

	const handleClose = () => {
		if (otp === '') {
			setErrorOtp(otp === '');
		} else {
			onClose(otp);
		}
	};

	const handleOTP = (event: React.ChangeEvent<{ value: unknown }>) => {
		setOtp(event.target.value as string);
	};

	const handleSendNewOtp = () => {
		onReloadOtp();
	};

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const classes = useStyles();

	return (
		<Dialog
			disableBackdropClick
			open={open}>
			<SDialogTitle className="pb-0" id="simple-dialog-title">BENVENUTO {username},
			</SDialogTitle>
			<SDialogSubtitle className="mx-4">per continuare, inserire il codice OTP inviato per email.</SDialogSubtitle>
			<DialogContent>
				<Grid container spacing={0} className="w-100">
					<FormControl required variant="outlined" className={classes.formControl} error={errorOtp}>
						<TextField
							className="w-100"
							id="otp"
							label="OTP"
							variant="outlined"
							value={otp}
							onChange={handleOTP}
							error={errorOtp || expiredOtp}
							helperText={errorOtp || expiredOtp && "OTP non valido"}
							InputLabelProps={{shrink: true}}
							required={true}
						/>
					</FormControl>
				</Grid>
			</DialogContent>
			<DialogActions className="p-4">
				{expiredOtp &&
					<SDialogButton className="float-right" onClick={handleSendNewOtp}>INVIA NUOVO OTP</SDialogButton>
				}

				<SDialogButton className="float-right" onClick={handleClose}>CONFERMA</SDialogButton>
			</DialogActions>
		</Dialog>
	);
}


export interface DialogProps {
	open: boolean;
	username: string;
	onClose: (punto: PuntoServizioDTO, canale: string, prestazioniConfList: PrestazioneConfigDTO[]) => void;
	puntiservizio: ComboBoxDTO[];
}

function AfterLoginDialog(props: DialogProps) {
	const {onClose, username, open, puntiservizio} = props;
	const [punto, setPunto] = useState<string>('');
	const [canale, setCanale] = useState<string>('');
	const [errorPunto, setErrorPunto] = useState<boolean>(false);
	const [errorCanale, setErrorCanale] = useState<boolean>(false);

	const handleClose = () => {
		if (punto === '' || canale === '') {
			setErrorCanale(canale === '');
			setErrorPunto(punto === '');
		} else {
			axios.all([
				axios.get('/api/puntoServizio/id/' + punto),
				axios.get('/api/puntoServizio/prestazioni/' + punto)
			])
				.then(axios.spread((res1, res2) => {
					onClose(res1.data, canale, res2.data);
				})).catch(error => {
				toast.error('🛑 Errore durante il recupero dei Punti di Servizio e Prestazioni di Config!');
				console.log(error);
			});
		}
	};

	const handlePuntoChangee = (event: React.ChangeEvent<{ value: unknown }>) => {
		setPunto(event.target.value as string);
	};

	const handleCanaleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setCanale(event.target.value as string);
	};

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const classes = useStyles();

	return (
		<Dialog
			disableBackdropClick
			open={open}>
			<SDialogTitle className="pb-0" id="simple-dialog-title">BENVENUTO {username},
			</SDialogTitle>
			<SDialogSubtitle className="mx-4">per continuare, seleziona il Punto di Servizio sul quale lavorerai e il Canale di Accesso predefinito</SDialogSubtitle>
			<DialogContent>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={6} className="pr-2">
						<FormControl required variant="outlined" className={classes.formControl} error={errorPunto}>
							<SInputLabel id="puntoServizio">Punto di Servizio</SInputLabel>
							<Select
								required
								labelId="puntoServizio"
								id="puntoServizioSelece"
								className={classes.selectEmpty}
								label="Punto di Servizio"
								value={punto}
								onChange={handlePuntoChangee}
								MenuProps={{
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left"
									},
									transformOrigin: {
										vertical: "top",
										horizontal: "left"
									},
									getContentAnchorEl: null
								}}
							>
								{puntiservizio?.map((item, index) => {
									return (
										<MenuItem value={item.key} key={item.key}>{item.value}</MenuItem>
									);
								})
								}
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={6} className="pl-2">
						<FormControl required variant="outlined" className={classes.formControl} error={errorCanale}>
							<SInputLabel id="canaleAccesso">Canale di Accesso predefinito</SInputLabel>
							<Select
								required
								labelId="canaleAccesso"
								id="canaleAccessoSelect"
								className={classes.selectEmpty}
								label="Canale di Accesso predefinito"
								value={canale}
								onChange={handleCanaleChange}
								MenuProps={{
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left"
									},
									transformOrigin: {
										vertical: "top",
										horizontal: "left"
									},
									getContentAnchorEl: null
								}}
							>
								<MenuItem value={CanaleAccessoEnum.FRONTOFFICE} key={CanaleAccessoEnum.FRONTOFFICE}>Frontoffice</MenuItem>
								<MenuItem value={CanaleAccessoEnum.CALL_CENTER} key={CanaleAccessoEnum.CALL_CENTER}>Call Center</MenuItem>
								<MenuItem value={CanaleAccessoEnum.MAIL} key={CanaleAccessoEnum.MAIL}>Mail</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right" onClick={handleClose}>CONFERMA</SDialogButton>
			</DialogActions>
		</Dialog>
	);
}

export default Login;
